// Models
import { IconButton, IconsType } from 'heeds-ds'

// React
import { FC } from 'react'

// Misc
import { buttonClickTracking } from 'utils/tracking'

// Components
import * as Styled from './styled'
import { Swipe } from 'heeds-ds'

export type TAction = {
  icon: IconsType
  color: string
  iconSize?: number
  onClick: () => void
}

type Props = {
  actions: TAction[]
  name: string
  onClick: () => void
}

const WorkoutModelCard: FC<Props> = ({ actions, name, onClick }) => {
  return (
    <Swipe active actions={actions}>
      <Styled.Card>
        <Styled.Title>{name}</Styled.Title>

        <IconButton
          iconName="arrowRight"
          onClick={onClick}
          track={buttonClickTracking}
          trackName="open_model_card_options"
        />
      </Styled.Card>
    </Swipe>
  )
}

export default WorkoutModelCard
